import { bundle01 } from "./data/bundle-01";
import { bundle02 } from "./data/bundle-02";
import { bundle03 } from "./data/bundle-03";
import { bundle04 } from "./data/bundle-04";
import { bundle05 } from "./data/bundle-05";
import type { Theme } from "./types";

export const themes: Theme[] = [...bundle01, ...bundle02, ...bundle03, ...bundle04, ...bundle05];

export const findThemeByName = (name: string, list: Theme[] = themes): Theme => {
  const found = list.find((t) => t.name === name);
  if (!found) {
    return list[0] as Theme;
  }
  return found;
};
